import { ChampionshipEditTab } from 'modules/championship/domain/enums/championship-edit-tab';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { ChampionshipInfoForm } from 'modules/championship/ui/components/championship-form';
import InfoFormSkeleton from 'modules/championship/ui/components/championship-form/info-form-skeleton';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { useSelector } from 'react-redux';
import { Route, Routes, useMatch } from 'react-router-dom';

import ChampionshipApplicationsPage from 'modules/teams/ui/pages/championship-applications-page';
import { ChampionshipStateData } from 'modules/championship/store/championship';
import { championshipIsLoadingSelector } from 'modules/championship/store/championship/selectors';
import ChampionshipRulesForm from '../form-parts/rules';
import ChampionshipMediaPage from '../form-parts/media/championship-media-page';
import ChampionshipStagesRoutes from '../form-parts/stages/stages-routes';
import ChampionshipSymbolicTeams from '../form-parts/symbolic-teams/symbolic-teams';

interface Props {
  championship?: ChampionshipStateData;
}

const ChampionshipEditForm = (props: Props) => {
  const { info } = useOrganizer();
  const isCommon = useMatch({ path: `${Pages.CHAMPIONSHIPS.EDIT}/${ChampionshipEditTab.COMMON}` });
  const { championship } = props;
  const isChampionshipLoading = useSelector(championshipIsLoadingSelector);

  if (isCommon && (!info || isChampionshipLoading || !championship)) {
    return <InfoFormSkeleton showDeleteButton={true} />;
  }

  if (!info || !championship) {
    return null;
  }

  return (
    <Routes>
      <Route path="rules" element={<ChampionshipRulesForm tournamentId={info!.id} championshipId={championship.id} />} />
      <Route path="applications/*" element={<ChampionshipApplicationsPage championshipId={championship.id} />} />
      <Route path="steps/*" element={<ChampionshipStagesRoutes championship={championship} />} />
      <Route
        path="media/*"
        element={<ChampionshipMediaPage championshipId={championship.id} organizerId={championship.tournamentId} />}
      />
      <Route
        path="symbolic-teams"
        element={<ChampionshipSymbolicTeams championshipId={championship.id} items={championship.symbolicTeams} />}
      />
      <Route path="*" element={<ChampionshipInfoForm tournamentId={info!.id} championshipId={championship.id} />} />
    </Routes>
  );
};

export default ChampionshipEditForm;
